const module = { name: 'fd-location/countrySwitcher', exports: {} }; const exports = module.exports;



import { Fandango_cookie as Fandango_cookie_get_getCookie_set_setCookie } from 'require-core';

const { get: getCookie, set: setCookie } = Fandango_cookie_get_getCookie_set_setCookie;


import { fd_url_manager as links } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const COUNTRY_DEFAULTS = Object.freeze({
    GB: {
        city: 'London',
        language: 'en-GB',
        lat: '51.50',
        long: '-0.12',
        postal: 'SW1A 1AA',
        region: 'Greater London',
    },
    IE: {
        city: 'Dublin',
        language: 'en-IE',
        lat: '53.35',
        long: '-6.26',
        postal: 'D01',
        region: 'Dublin',
    },
    US: {
        city: 'Beverly Hills',
        language: 'en-US',
        lat: '34.09',
        long: '-118.40',
        postal: '90210',
        region: 'CA',
    },
})


const HOST_COUNTRIES = Object.freeze({
    com: ['US'],
    'co.uk': ['GB', 'IE'],
})
function detectHostTLD() {
    const hostname = window.location.hostname;
    if (hostname.match(/fandango\.co\.uk$/)) {
        return 'co.uk';
    }
    return 'com';
}
function getLocalCountries() {
    return HOST_COUNTRIES[detectHostTLD()] || HOST_COUNTRIES.com;
}
function getDefaultCountry() {
    return getLocalCountries()[0];
}
function getCookieDomain() {
    const match = window.location.hostname.match(/\.(fandango\.(?:co\.uk|com))$/);
    if (match) {
        return `.${match[1]}`;
    }
    return detectHostTLD() === 'co.uk' ? '.fandango.co.uk' : '.fandango.com';
}
function getCurrentCountry() {
    const raw = getCookie('userCountry');
    if (raw) {
        const parts = raw.split('|');
        if (parts.length === 2) {
            return parts[0].toUpperCase();
        }
    }
    return getDefaultCountry();
}
function isSameHost(targetCountry) {
    const localCountries = getLocalCountries();
    const currentCountry = getCurrentCountry();
    return localCountries.includes(currentCountry) && localCountries.includes(targetCountry);
}
function getTargetDomain(country) {
    const targetTLD = Object.keys(HOST_COUNTRIES).find(tld => HOST_COUNTRIES[tld].includes(country));
    if (targetTLD === 'com') {
        if (typeof links.fandangoUS === 'function') {
            return links.fandangoUS();
        }
        if (typeof links.baseCanonicalUrl === 'function') {
            return links.baseCanonicalUrl();
        }
        if (typeof links.baseCanonical === 'function') {
            return links.baseCanonical();
        }
    }
    if (targetTLD === 'co.uk') {
        if (typeof links.fandangoUK === 'function') {
            return links.fandangoUK();
        }
        if (typeof links.baseCanonicalUrl === 'function') {
            return links.baseCanonicalUrl();
        }
        if (typeof links.baseCanonical === 'function') {
            return links.baseCanonical();
        }
    }
    return '';
}
function getRegionTokenUrl(country) {
    if (typeof links.napiRegionToken === 'function') {
        return links.napiRegionToken({}, { country });
    }
    if (typeof links.snapiRegionToken === 'function') {
        return links.snapiRegionToken({}, { country });
    }
    return `/napi/intl/region-token?country=${country}`;
}
function buildLocationCookieValue(country) {
    const d = COUNTRY_DEFAULTS[country];
    if (!d) {
        return '';
    }
    return [
        `city=${encodeURIComponent(d.city)}`,
        `country=${country}`,
        `language=${d.language}`,
        `lat=${d.lat}`,
        `long=${d.long}`,
        `postal=${encodeURIComponent(d.postal)}`,
        `region=${encodeURIComponent(d.region)}`,
    ].join('&');
}
function sameHostSwitch(country) {
    const domain = getCookieDomain();
    const opts = { domain, secure: true, expires: 365 };
    setCookie('userCountry', `${country}|${COUNTRY_DEFAULTS[country].language}`, opts);
    setCookie('userlocation', buildLocationCookieValue(country), opts);
    window.location.reload();
}
function crossHostSwitch(country) {
    const targetDomain = getTargetDomain(country);
    const setRegionPath = typeof links.intlSetRegion === 'function' ? links.intlSetRegion() : '/intl/set-region';
    xhr.ajax({
        method: 'GET',
        url: getRegionTokenUrl(country),
    })
        .done(({ token }) => {
        const encodedToken = encodeURIComponent(token);
        window.location.href =
            `${targetDomain}${setRegionPath}?country=${country}&token=${encodedToken}&redirect=/`;
    })
        .fail(() => {
        console.error('countrySwitcher: cross-host switch failed');
    });
}
function switchCountry(targetCountry) {
    const country = targetCountry.toUpperCase();
    if (!COUNTRY_DEFAULTS[country]) {
        return;
    }
    if (isSameHost(country)) {
        sameHostSwitch(country);
    }
    else {
        crossHostSwitch(country);
    }
}
module.exports = {
    switchCountry,
    getCurrentCountry,
    getDefaultCountry,
    getLocalCountries,
    isSameHost,
    COUNTRY_DEFAULTS,
    HOST_COUNTRIES,
};
export default module.exports;